import { AxiosResponse } from 'axios';
import { store } from '../store';
import { SKW_PREFIX } from '../utils/constants';
import api from './api';

export const UDNICK = {
  callService: (
    serviceName: string,
    data?: object,
    queryParams?: object
  ): Promise<AxiosResponse> => {
    const { auth } = store.getState();
    return api.post('/call', data || {}, {
      params: {
        serviceName: SKW_PREFIX + serviceName,
        token: auth ? auth.token : null,
        ...queryParams,
      },
    });
  },
};
